import React from "react";
import { motion } from "framer-motion";
import "./Home.css";
import Testimonials from "./Testimonials";
import AboutSection from "./AboutSection";
import FeatureSection from "./FeatureSection";

import { Typewriter } from "react-simple-typewriter";
import NewsSection from "../components/NewsSection";
import FeaturedProjects from "../components/FeaturedProjects";
import Background from "./Background";
import { Helmet, HelmetProvider } from 'react-helmet-async';


const services = [
  "Logo Design",
  "Web Development",
  "Mobile App Development",
  "UI/UX Design",
  "SEO & Digital Marketing",
  "Software Consulting",
];

const team = [
  { name: "Chidi Nwosu", role: "Fullstack Developer" },
  { name: "Amina Bello", role: "Product Designer" },
  { name: "Tunde Bakare", role: "Mobile Developer" },
  { name: "Sandra Ijeoma", role: "Project Manager" },
];

const textVariant = {
  hidden: { opacity: 0, y: 20 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.3, duration: 0.6 },
  }),
};

export default function Home() {
  return (
    
    <div className="home-container">
  <Helmet>
    <title>Mosaic Tech — Full-stack Web & Web3 Development Agency</title>
    <meta
      name="description"
      content="Mosaic Tech builds scalable web apps, mobile solutions, and Web3 utilities for global startups. Contact us to scale your next big idea."
    />
    <meta name="keywords" content="Web3, Software Development, Blockchain, NFT, AI, Mobile Apps, Mosaic Tech" />
    <meta name="author" content="Mosaic Tech" />
  </Helmet>

  <section className="concept-banner">
    <div className="logo-banner"></div>
  </section>
      

      {/* HERO SECTION */}
      <section className="hero">
        {/* Background animation container */}
        <div className="hero-bg-blur" />

        <div className="hero-content">
          <motion.h1
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="hero-heading">
              <Typewriter
                words={[
                  "We build your thoughts.",
                  "Making you money is our canvas.",
                  "Web3. AI. Mobile. Magic. KoL",
                ]}
                loop
                cursor
                cursorStyle="|"
                typeSpeed={70}
                deleteSpeed={40}
                delaySpeed={2000}
              />
            </span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            Mosaic is a Web3 company that does everything Web3: trading, smart
            contracts, launching memes, Sol trading bots, raid management
            systems, NFT minting, marketing — anything you can possibly think
            of.
          </motion.p>

          <motion.p>
            You're in the right place. We're sure you'll find what you're
            looking for here.
          </motion.p>

          <motion.a
            href="#services"
            className="cta-button"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            Explore Services
          </motion.a>
        </div>
      </section>

      {/* SERVICES SECTION */}
      <section id="services" className="services">
        <h2>Our Services</h2>
        <div className="service-grid">
          {services.map((service, idx) => (
            <motion.div
              key={idx}
              className="service-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.2 }}
            >
              {service}
            </motion.div>
          ))}
        </div>
      </section>
      {/* TEAM SECTION */}
      {/* <section className="team-section">
        <h2>Meet the Team</h2>
        <div className="team-grid">
          {team.map((member, idx) => (
            <motion.div
              key={idx}
              className="team-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.3 }}
            >
              <div className="avatar">{member.name.charAt(0)}</div>
              <h3>{member.name}</h3>
              <p>{member.role}</p>
            </motion.div>
          ))}
        </div>
      </section> */}
      <Testimonials />
      <AboutSection />
      <FeatureSection />
      <Background />
      <FeaturedProjects />
      <NewsSection />
    </div>
  );
}
